export enum Risicoklasse {
  /// <summary>
  /// Risicoklasse is niet bekend
  /// </summary>
  Onbekend = 0,
  /// <summary>
  /// Leensom is kleiner dan of gelijk aan 50% van de marktwaarde van de woning
  /// </summary>
  KleinerDanOfGelijkAan50ProcentMarktwaarde = 1,
  /// <summary>
  /// Leensom is kleiner dan of gelijk aan 65% van de marktwaarde van de woning
  /// </summary>
  KleinerDanOfGelijkAan65ProcentMarktwaarde = 2,
  /// <summary>
  /// Nationale Hypotheek Garantie
  /// </summary>
  Nhg = 3,
  /// <summary>
  /// Gemeentegarantie
  /// </summary>
  Gemeentegarantie = 4
}
